import { createClient } from "@sanity/client";

export const client = createClient({
    projectId: "d139wimd",     // e.g. abc123xyz
    dataset: "production",            // or your dataset name
    apiVersion: "2024-01-01",
    useCdn: true,
    token: "skjzdecrGhey3QQP5McxiuXIR8jftpdtvOHYMCiygDOvoxUl0keKfzSXrAjPkPi40d9iM1Om5koXRPeE7XJHlsiEyXgkAEBygqnFAr0hLKvQ8Q7DKAUwmQZ2O5zuRioXysPGe7Hm6ogKVpDJlz7H7UkxIhoD65sk2BRTZt6MY1EerQqeEYtY"        // optional, required for write access
});
